import { jsxs, jsx } from "react/jsx-runtime";
import { useRef, useState, useCallback, useEffect } from "react";
import { Wrapper, Code, Textarea } from "./select-mock.styles.js";
function PostMessageComponent() {
  const textarea = useRef(null);
  const [postMessages, setPostMessages] = useState([]);
  const [indexSelected, setIndexSelected] = useState(0);
  const addMessage = useCallback(
    (event) => {
      try {
        const source = event.data?.source;
        const isDevTools = source?.includes("react-devtools");
        if (!isDevTools)
          setPostMessages([
            ...postMessages,
            JSON.stringify(event.data, null, 2)
          ]);
      } catch (e) {
        setPostMessages([...postMessages, `${e}`]);
      }
    },
    [postMessages]
  );
  useEffect(() => {
    window.addEventListener("message", addMessage);
    return () => {
      window.removeEventListener("message", addMessage);
    };
  }, [addMessage]);
  function handleEventMessage() {
    if (textarea.current) {
      try {
        const data = JSON.parse(textarea.current.value);
        window.postMessage(data, "*");
      } catch (e) {
        setPostMessages([...postMessages, `${e}`]);
      }
    }
  }
  function handleSelect(index) {
    return () => {
      setIndexSelected(index);
    };
  }
  function handleClear() {
    setPostMessages([]);
  }
  return /* @__PURE__ */ jsxs(Wrapper, { children: [
    /* @__PURE__ */ jsx("label", { children: "Post message Listener:" }),
    postMessages.map((p, index) => /* @__PURE__ */ jsx(
      Code,
      {
        selected: index === indexSelected,
        onClick: handleSelect(index),
        children: p
      },
      index
    )),
    /* @__PURE__ */ jsx(Textarea, { ref: textarea }),
    /* @__PURE__ */ jsx("button", { type: "button", onClick: handleEventMessage, children: "Disparar evento" }),
    /* @__PURE__ */ jsx("button", { type: "button", onClick: handleClear, children: "Clear history" })
  ] });
}
export {
  PostMessageComponent
};
//# sourceMappingURL=post-message.component.js.map
